/* Header badge: total missing files across the document tools the user can open. */
import { useCallback, useEffect, useState } from "react";
import { FileWarning } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { loadMissing } from "@/components/MissingFilesCard";

const TOOLS = [
  ["packing_list", "packing_list", "doc_packing_list", "Packing List"],
  ["bulk_data", "bulk_data", "doc_bulk_data", "Bulk Data"],
  ["pack_team", "pack_team_print", "doc_pack_team_print", "Pack Team Print"],
  ["bulk_label", "bulk_label", "doc_bulk_label", "Bulk Label"],
  ["invoice", "invoice", "doc_invoice", "Invoice"],
];

export const MissingFilesBadge = ({ user, onOpen }) => {
  const mine = TOOLS.filter(t => user?.role === "admin" || (user?.document_sub_panels || {})[t[1]] === true);
  const [counts, setCounts] = useState(null);
  const [open, setOpen] = useState(false);
  const key = mine.map(t => t[0]).join(",");
  const load = useCallback(async () => {
    if (!key) return;
    const tools = key.split(",");
    const lists = await Promise.all(tools.map(loadMissing));
    setCounts(Object.fromEntries(tools.map((t, i) => [t, lists[i].length])));
  }, [key]);
  useEffect(() => {
    load();
    const id = setInterval(() => { if (!document.hidden) load(); }, 120000);
    window.addEventListener("order-register:invoice-changed", load);
    return () => { clearInterval(id); window.removeEventListener("order-register:invoice-changed", load); };
  }, [load]);
  if (!mine.length || !counts) return null;
  const total = Object.values(counts).reduce((a, b) => a + b, 0);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" className="relative rounded-lg p-2 hover:bg-slate-100 transition-colors"
          title={total ? `${total} missing files (completed yesterday / today)` : "No missing files"} data-testid="header-missing-files-badge">
          <FileWarning className={`h-5 w-5 ${total ? "text-amber-600" : "text-slate-400"}`} />
          {total > 0 && <span className="absolute -right-0.5 -top-0.5 min-w-[18px] rounded-full bg-amber-500 px-1 text-[10px] font-bold leading-[18px] text-white"
            data-testid="header-missing-files-count">{total}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-64 p-2" data-testid="header-missing-files-pop">
        <p className="px-1 pb-1.5 text-[11px] font-semibold text-slate-600">Missing files — completed yesterday / today</p>
        {mine.map(([t, , panel, label]) => (
          <button key={t} type="button" onClick={() => { setOpen(false); onOpen(panel); }}
            className="flex w-full items-center justify-between rounded px-2 py-1.5 text-xs hover:bg-slate-100" data-testid={`header-missing-files-${t}`}>
            {label}
            <span className={`rounded-full px-1.5 text-[10px] font-bold ${counts[t] ? "bg-amber-500 text-white" : "bg-emerald-100 text-emerald-700"}`}>{counts[t]}</span>
          </button>))}
      </PopoverContent>
    </Popover>
  );
};
